<app-table
    [data]="data"
    [displayedColumns]="displayedColumns"
    [currentSortOption]="currentSortOption"
    [loading]="loading"
    [titleColumnText]="titleColumnText"
    [noContentText]="noContentText"
    (dataSourceChangeInfinityScroll)="onDataSourceChangeInfinityScroll()"
    (sortOptions)="onSortOptions($event)"
    (copyEmitter)="onCopy($event)"
></app-table>
